import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import './LikeWidget.css';
import { reportError } from '..';
export var LikeWidget = function (_a) {
    var votes = _a.votes, userVoted = _a.userVoted, onVote = _a.onVote;
    return (React.createElement("div", { className: "like-widget" },
        React.createElement(Button, { icon: true, disabled: userVoted, onClick: function (e) {
                e.stopPropagation();
                onVote().catch(reportError);
            } },
            React.createElement(Icon, { size: "big", name: "thumbs up outline" })),
        !!votes && React.createElement("div", { className: "votes-count" }, votes)));
};
//# sourceMappingURL=LikeWidget.js.map